import React, { useEffect, useState } from 'react';
import { Card, Spinner, ErrBox } from '../../../components/UI';
import { procurementAPI } from '../../../utils/api';
import { fmtRp, fmtDate } from '../../../utils/format';

export default function DashboardTab() {
  const [dash, setDash] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try { setLoading(true); const d = await procurementAPI.getDashboard(); setDash(d.data || d); setError(null); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  if (loading) return <div style={{ padding: '2rem', textAlign: 'center' }}><Spinner /></div>;
  if (error) return <ErrBox msg={error} onRetry={load} />;
  if (!dash) return null;

  const s = dash;

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <Card style={{ borderLeft: '4px solid #2563EB', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Total PR</p>
          <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#1E40AF' }}>{s.total_requests || 0}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>permintaan</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #059669', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Total Nilai</p>
          <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#047857' }}>{fmtRp(s.total_value || 0)}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>Rp</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #7C3AED', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Asset</p>
          <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#6D28D9' }}>{(s.by_type || []).find(t => t.request_type === 'ASSET')?.count || 0}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>pengadaan</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #F59E0B', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Inventory</p>
          <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#D97706' }}>{(s.by_type || []).find(t => t.request_type === 'INVENTORY')?.count || 0}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>pengadaan</p>
        </Card>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <Card>
          <h3 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: 700, color: '#111827' }}>Status PR</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#F9FAFB' }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Status</th>
                <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Jumlah</th>
              </tr>
            </thead>
            <tbody>
              {(s.by_status || []).map((row, idx) => {
                const badge = { DRAFT: '#6B7280', PENDING_APPROVAL: '#F59E0B', APPROVED: '#059669', REJECTED: '#DC2626', ORDERED: '#2563EB', RECEIVED: '#7C3AED', COMPLETED: '#059669' };
                return (
                  <tr key={idx} style={{ borderBottom: '1px solid #F3F4F6' }}>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: badge[row.status] + '20', color: badge[row.status] || '#374151' }}>
                        {row.status}
                      </span>
                    </td>
                    <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>{row.count}</td>
                  </tr>
                );
              })}
              {(!s.by_status || s.by_status.length === 0) && (
                <tr><td colSpan={2} style={{ padding: 20, textAlign: 'center', color: '#9CA3AF' }}>Tidak ada data</td></tr>
              )}
            </tbody>
          </table>
        </Card>

        <Card>
          <h3 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: 700, color: '#111827' }}>PR Terbaru</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#F9FAFB' }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>No. PR</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Unit</th>
                <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Nilai</th>
              </tr>
            </thead>
            <tbody>
              {(s.recent || []).map((row, idx) => (
                <tr key={idx} style={{ borderBottom: '1px solid #F3F4F6' }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600, color: '#2563EB' }}>{row.request_no}</td>
                  <td style={{ padding: '10px 12px', color: '#374151' }}>{row.unit_name || '-'}</td>
                  <td style={{ padding: '10px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600, color: '#1E40AF' }}>{fmtRp(row.total_amount)}</td>
                </tr>
              ))}
              {(!s.recent || s.recent.length === 0) && (
                <tr><td colSpan={3} style={{ padding: 20, textAlign: 'center', color: '#9CA3AF' }}>Tidak ada data</td></tr>
              )}
            </tbody>
          </table>
        </Card>
      </div>
    </div>
  );
}